import { SvgIcon, SvgIconProps } from "@mui/material";

export const IntegrationSourceIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M13.679 23h-3.358a1.778 1.778 0 0 1-1.778-1.779v-3.765A3.457 3.457 0 0 1 12 14v0a3.457 3.457 0 0 1 3.457 3.457v3.765c0 .982-.796 1.778-1.778 1.778Z"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M9 8.243a4.242 4.242 0 0 1 6 0M10.5 10.621a2.122 2.122 0 0 1 3 0"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5 19a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2"
      />
    </svg>
  </SvgIcon>
);
